import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// styles
import * as styles from "./Featured.module.css";

const Featured = props => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  return (
    <section className={styles.featuredWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"} ${
          styles.featured_container
        }`}
      >
        <div className="row">
          <div className="col-12 text-center">
            <h1 className={styles.featured_heading}>As featured in</h1>
          </div>
        </div>

        <div className={styles.featured_card}>
          <div className={`${styles.featured_card_hover}`} role="button">
            <StaticImage
              src="../../../images/featured/fortune_logo.png"
              alt="fortune_logo"
              className={styles.featured_image}
              placeholder="blurred"
              quality={100}
              objectFit="contain"
            />
          </div>

          <div className={`${styles.featured_card_hover}`}>
            <StaticImage
              src="../../../images/featured/business_insider_logo.png"
              alt="business insider"
              className={styles.featured_image}
              placeholder="blurred"
              quality={100}
              objectFit="contain"
            />
          </div>

          <div className={`${styles.featured_card_hover}`}>
            <StaticImage
              src="../../../images/featured/axios_logo.png"
              alt="axios"
              className={styles.featured_image}
              placeholder="blurred"
              quality={100}
              objectFit="contain"
            />
          </div>

          <div className={`${styles.featured_card_hover}`} role="button">
            <StaticImage
              src="../../../images/featured/medpage_today_logo.png"
              alt="medpage today"
              className={styles.featured_image}
              placeholder="blurred"
              quality={100}
              objectFit="contain"
            />
          </div>

          <div className={`${styles.featured_card_hover}`} role="button">
            <StaticImage
              src="../../../images/featured/bloomberg_logo.png"
              alt="bloomberg"
              className={styles.featured_image}
              placeholder="blurred"
              quality={100}
              objectFit="contain"
            />
          </div>

          <div className={`${styles.featured_card_hover}`} role="button">
            <StaticImage
              src="../../../images/featured/prevention_logo.png"
              alt="prevention"
              className={styles.featured_image}
              placeholder="blurred"
              quality={100}
              objectFit="contain"
            />
          </div>

          <div className={`${styles.featured_card_hover}`} role="button">
            <StaticImage
              src="../../../images/featured/women_world_logo.png"
              alt="women's world"
              className={styles.featured_image}
              placeholder="blurred"
              quality={100}
              objectFit="contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Featured;
